var React = require('react');

function LineWithArrow (props) {
    return React.createElement("svg",props,[React.createElement("line",{"x1":"0","y1":"30","x2":"100","y2":"30","stroke":"black","strokeWidth":"5","key":0}),React.createElement("polygon",{"points":"0,0 30,0 15,30","key":1})]);
}

LineWithArrow.defaultProps = {};

module.exports = LineWithArrow;

LineWithArrow.default = LineWithArrow;
